// Native posters can disappear at play(), before the decoder has a frame.
export default function VideoPoster({ src, ready }: { src: string; ready: boolean }) {
  return <img className="video-poster-layer" src={src} alt="" aria-hidden="true" hidden={ready} decoding="async" draggable="false" />
}
